module.exports = "<div class=\"description\">\n  <i class=\"icon icon-question\"></i>\n  <p>\n    <a href=\"\" (click)=\"toggle()\">{{ title }}</a>\n  </p>\n  <div *ngIf=\"open\" @slideOpen>\n    <ng-content></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/description/description.component.html
// module id = ../../../../../src/app/shared/description/description.component.html
// module chunks = 2